import { POSITRON } from '@carto/react-basemaps';

export const initialState = {
    viewState: {
        latitude: 39.1547,
        longitude: -77.2405,
        zoom: 3,
        pitch: 0,
        bearing: 0,
        dragRotate: false,
    },
    basemap: POSITRON,
    credentials: {
        username: 'touchstone',
        apiKey: 'default_public',
        serverUrlTemplate: 'https://{user}.carto.com',
    },
    googleApiKey: '', // only required when using a Google Basemap
};

export const oauthInitialState = {
    token: null,
};
